import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';

import Card from './Card';
import CardHeading from './Heading';

const ON_SITE_TAGS = [
  {
    icon: 'search',
    text: 'Busca Patrocinada',
  },
  {
    icon: 'important-devices',
    text: 'Blog',
  },
  {
    icon: 'location',
    text: 'Oferta Fixada',
  },
  {
    icon: 'rating-star-filled',
    text: 'Ícone Especial',
  },
  {
    icon: 'view-list',
    text: 'Banner',
  },
];

const PurpleCard = ({ className }) => (
  <div
    className={twJoin(
      'flex flex-col-reverse items-center gap-x-6 gap-y-2 overflow-hidden md:flex-row md:gap-y-0',
      className
    )}
  >
    <Card
      heading={<CardHeading subtitle="Campanhas Segmentadas" title="ON Site" />}
      tags={ON_SITE_TAGS}
      type="secondary"
    />
    <Heading className="text-gradient-highlight" size="size1">
      Vendas e <br /> Performance
    </Heading>
  </div>
);

PurpleCard.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default PurpleCard;
